import { ITypeDefinition } from './TypeDefinitionFactory';
import { sanitize } from 'sanitize-xml-string';

export default class StringDefinition implements ITypeDefinition {
  formatToLocale(value: string) {
    return value;
  }

  parseToXmlValue(value: string) {
    return sanitize(value, '');
  }

  isValid(value: string) {
    return true;
  }
}
